import type { FaireProductEntity } from "../../entity_types/product";

export const p_zp8t5mpvt4: FaireProductEntity = {
  token: "p_zp8t5mpvt4",
  type: "product",
  name: "Gray Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/917128cb06c323352dd623d5503af9bb6de219f274bfc7a4c91c6570fa4a000a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a0e0a7480a0eaa272c9d8b1d1d1135003d84bba00fd52cfa6b64d26ce7d9a42.jpeg",
    "https://cdn.faire.com/fastly/f9fff7ed27ccb079fcea1ae225272766c5e4b830af6d6b1e40139fe4f0c83efd.jpeg",
    "https://cdn.faire.com/fastly/4bdb9d0c2d20ec1d1559090fa2e1938dd270f25b20eb6e2c2a93113633447435.jpeg",
    "https://cdn.faire.com/fastly/d7227dbfebd790096973d40e561023798c552b7805fbf28b1fb6109b9c66df4c.jpeg"
  ],
  priceDollars: 33.95,
  description: "Gray Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:58.005Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
